import { createFileRoute } from '@tanstack/react-router';
import { RouteGuard } from '../../lib/route-guard.js';
import { SalesOrderCreateForm } from '../../modules/sales/sales-order-create-form.js';

export const Route = createFileRoute('/sales-orders/new')({
  // `draftId` resumes a Draft-status list row and `customerId`/`brandId` start a new order for them
  // (e.g. from a customer page); all are optional so a plain "+ New Sales Order" link needn't pass `search`.
  validateSearch: (
    search: Record<string, unknown>,
  ): { draftId?: string; customerId?: string; brandId?: string } => ({
    draftId: typeof search.draftId === 'string' ? search.draftId : undefined,
    customerId: typeof search.customerId === 'string' ? search.customerId : undefined,
    brandId: typeof search.brandId === 'string' ? search.brandId : undefined,
  }),
  component: NewSalesOrderPage,
});

// eslint-disable-next-line react-refresh/only-export-components
function NewSalesOrderPage() {
  const { draftId, customerId, brandId } = Route.useSearch();
  return (
    <RouteGuard route="/sales-orders/new">
      <div>
        <SalesOrderCreateForm
          draftId={draftId}
          initialBrandId={brandId}
          initialCustomerId={customerId}
        />
      </div>
    </RouteGuard>
  );
}
